import { StackProps, VStack } from "@chakra-ui/react";
import { TitlePageDashboard } from "../../../components/button/TitlePageDashboard";
import { HistoryWithdrawTable } from "../../../components/dashboard_reseller/HistoryWithdrawTable";

interface Props extends StackProps {
  pageType: number;
}

export const Withdraw = ({ pageType, ...rest }: Props) => {
  return (
    <VStack
      className="withdraw-page"
      w={"100%"}
      p={4}
      gap={4}
      align={"stretch"}
      {...rest}
    >
      <TitlePageDashboard
        title="Withdraw"
        subtitle="Anda bisa melihat seluruh riwayat tranksasi penjualan dan withdraw yang anda lakukan di tabel"
        isSubPage={true}
      />

      <HistoryWithdrawTable pageType={pageType} />
    </VStack>
  );
};
